import qs from "qs";
var NEWCAR_URL = "https://c.8891.com.tw";
var NEWCAR_APP_URL = "tcnewcar://newcar";
var USEDCAR_AUTO_URL = "https://auto.8891.com.tw";
var USEDCAR_URL = "https://m.8891.com.tw";
var USEDCAR_APP_URL = "tc://8891";
function strParams(params) {
  var query = params.query ? "?".concat(qs.stringify(params.query)) : "";
  return {
    app: "".concat(params.app).concat(query),
    // iOS: `${params.iOS || params.app}${query}`,
    // android: `${params.android || params.app}${query}`,
    touch: "".concat(params.touch).concat(query),
    desktop: "".concat(params.desktop).concat(query)
  };
}
export default {
  newCarLinks: {
    info: function info(params) {
      return strParams({
        query: params,
        app: "".concat(NEWCAR_APP_URL, "/info"),
        touch: "".concat(NEWCAR_URL, "/m/kindsum/"),
        desktop: "".concat(NEWCAR_URL, "/photoModel-info.html")
      });
    },
    brand: function brand(params) {
      return strParams({
        query: params,
        app: "".concat(NEWCAR_APP_URL, "/brand"),
        touch: "".concat(NEWCAR_URL, "/m/brand"),
        desktop: "".concat(NEWCAR_URL, "/Models")
      });
    },
    inquiry: function inquiry(params) {
      return {
        app: "tcnewcar://newcar/inquiryNew?b=".concat(params.b, "&k=").concat(params.k, "&myid=0&source=").concat(encodeURIComponent(params.source)),
        touch: "/m/ask/price?b=".concat(params.b, "&k=").concat(params.k, "&source=").concat(params.source),
        desktop: "".concat(NEWCAR_URL, "/ask/price?b=").concat(params.b, "&k=").concat(params.k, "&source=").concat(params.source)
      };
    }
  },
  usedCarLinks: {
    detail: function detail(params) {
      return {
        iOS: "tc://usedauto/item/".concat(params.id),
        android: "".concat(USEDCAR_APP_URL, "/auto/detail?id=").concat(params.id),
        touch: "".concat(USEDCAR_URL, "/auto?id=").concat(params.id),
        desktop: "".concat(USEDCAR_AUTO_URL, "/usedauto-infos-").concat(params.id, ".html")
      };
    }
  }
};